import { useAppSelector } from './store';

export default function useAuthSelector() {
    const { isAuthenticated, user } = useAppSelector(state => state.reducer.auth);
    return { isAuthenticated, user };
}
